function getDeclensionLabel(count: number, label: string) {
  if (count < 2) {
    return label
  }

  return `${label}s`
}

export default getDeclensionLabel
